export function updateCode( value ){
    return{
        type: 'code/UPDATE',
        payload: value
    };
}